import { useInfiniteQuery, useQuery } from 'react-query'

import { DeduplicationService } from '../services'

const PAGE_SIZE = 100

export type RunEventsFilterParams = {
  phase?: string
  action?: string
  event?: string
}

const hasActiveFilters = (filters: RunEventsFilterParams) =>
  Boolean(filters.phase || filters.action || filters.event)

export const useDeduplicationRunEventsInfinite = (
  runId: string,
  filters: RunEventsFilterParams = {}
) => {
  const filtered = hasActiveFilters(filters)

  const filteredQuery = useQuery(
    ['deduplication-run-events-filtered', runId, filters],
    () =>
      DeduplicationService.getRunEvents(runId, {
        limit: 500,
        phase: filters.phase,
        action: filters.action,
        event: filters.event,
      }),
    {
      enabled: !!runId && filtered,
    }
  )

  const infiniteQuery = useInfiniteQuery(
    ['deduplication-run-events-infinite', runId],
    ({ pageParam }) =>
      DeduplicationService.getRunEvents(runId, {
        limit: PAGE_SIZE,
        cursor: pageParam as string | undefined,
      }),
    {
      enabled: !!runId && !filtered,
      getNextPageParam: (lastPage) => lastPage.cursor ?? undefined,
    }
  )

  if (filtered) {
    return {
      data: filteredQuery.data
        ? { pages: [{ events: filteredQuery.data.events, cursor: null }], pageParams: [undefined] }
        : undefined,
      isLoading: filteredQuery.isLoading,
      isError: filteredQuery.isError,
      error: filteredQuery.error,
      isFetchingNextPage: false,
      hasNextPage: false,
      fetchNextPage: async () => undefined,
    }
  }

  return infiniteQuery
}
